export default {
  total: 'Total {total} items',
  page_size: '{size} items/page',
  goTo: 'Go to',
  page: 'page',
};
